export default "__VITE_ASSET__CLjap658__"